(function () {
  "use strict";

  var STORAGE_KEY = "evlg-bauer-anfragekorb-v1";
  var currencyFormatter = new Intl.NumberFormat("de-DE", {
    style: "currency",
    currency: "EUR",
    minimumFractionDigits: 2,
  });

  function escapeHtml(value) {
    return String(value == null ? "" : value)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;")
      .replace(/'/g, "&#039;");
  }

  function normalize(value) {
    return String(value == null ? "" : value)
      .toLocaleLowerCase("de-DE")
      .replace(/ß/g, "ss")
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/[^a-z0-9]+/g, " ")
      .trim();
  }

  function formatCurrency(value) {
    return typeof value === "number" && Number.isFinite(value) ? currencyFormatter.format(value) : "auf Anfrage";
  }

  function formatNumber(value) {
    return new Intl.NumberFormat("de-DE").format(value || 0);
  }

  function loadCart() {
    try {
      var parsed = JSON.parse(localStorage.getItem(STORAGE_KEY) || "[]");
      return Array.isArray(parsed) ? parsed : [];
    } catch (error) {
      return [];
    }
  }

  function saveCart(cart) {
    try {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(cart));
    } catch (error) {
      /* The cart remains available for the current page session. */
    }
  }

  function uniqueSorted(values) {
    return Array.from(new Set(values.filter(Boolean))).sort(function (a, b) {
      return a.localeCompare(b, "de", { numeric: true, sensitivity: "base" });
    });
  }

  function initCatalog(root) {
    if (root.dataset.bauerInitialized === "true") return;
    root.dataset.bauerInitialized = "true";

    var catalog = window.BAUER_CATALOG_DATA;
    var grid = root.querySelector("[data-product-grid]");
    var liveStatus = root.querySelector("[data-live-status]");
    if (!catalog || !Array.isArray(catalog.products)) {
      grid.innerHTML = '<div class="bauer-empty"><h3>Produktdaten konnten nicht geladen werden.</h3><p>Bitte laden Sie die Seite erneut.</p></div>';
      grid.setAttribute("aria-busy", "false");
      return;
    }

    var products = catalog.products;
    var productById = new Map(products.map(function (product) { return [product.id, product]; }));
    var pageSize = Number(root.dataset.pageSize) || 24;
    var visibleLimit = pageSize;
    var state = {
      query: "",
      productArea: "",
      productGroup: "",
      productType: "",
      productName: "",
      priceStatus: "",
      sort: "title",
    };
    var cart = loadCart().filter(function (item) { return productById.has(item.id); });

    var searchInput = root.querySelector("[data-search-input]");
    var resultCount = root.querySelector("[data-result-count]");
    var emptyState = root.querySelector("[data-empty-state]");
    var loadMoreWrap = root.querySelector("[data-load-more-wrap]");
    var productModal = root.querySelector("[data-product-modal]");
    var productModalContent = root.querySelector("[data-product-modal-content]");
    var checkoutModal = root.querySelector("[data-checkout-modal]");
    var cartDrawer = root.querySelector("[data-cart-drawer]");
    var overlay = root.querySelector("[data-overlay]");
    var cartItems = root.querySelector("[data-cart-items]");
    var cartEmpty = root.querySelector("[data-cart-empty]");
    var cartFooter = root.querySelector("[data-cart-footer]");
    var cartTotal = root.querySelector("[data-cart-total]");
    var orderPreview = root.querySelector("[data-order-preview]");
    var orderBody = root.querySelector("[data-order-body]");
    var orderForm = root.querySelector(".bauer-order-form");

    root.querySelectorAll("[data-product-total]").forEach(function (node) {
      node.textContent = formatNumber(catalog.meta.productCount);
    });

    function populateSelect(filterName, values) {
      var select = root.querySelector('[data-filter="' + filterName + '"]');
      if (!select) return;
      var first = select.options[0].outerHTML;
      select.innerHTML = first + values.map(function (value) {
        return '<option value="' + escapeHtml(value) + '">' + escapeHtml(value) + "</option>";
      }).join("");
    }

    populateSelect("productArea", catalog.meta.filterValues.productAreas);
    populateSelect("productGroup", catalog.meta.filterValues.productGroups);
    populateSelect("productType", catalog.meta.filterValues.productTypes);
    populateSelect("productName", catalog.meta.filterValues.productNames);

    function filterProducts() {
      var queryTokens = normalize(state.query).split(" ").filter(Boolean);
      var filtered = products.filter(function (product) {
        if (queryTokens.length) {
          var haystack = normalize(product.searchText);
          if (!queryTokens.every(function (token) { return haystack.indexOf(token) !== -1; })) return false;
        }
        if (state.productArea && product.productAreas.indexOf(state.productArea) === -1) return false;
        if (state.productGroup && product.productGroups.indexOf(state.productGroup) === -1) return false;
        if (state.productType && product.productTypes.indexOf(state.productType) === -1) return false;
        if (state.productName && product.productNames.indexOf(state.productName) === -1) return false;
        if (state.priceStatus === "available" && product.priceOnRequest) return false;
        if (state.priceStatus === "request" && !product.priceOnRequest) return false;
        return true;
      });

      filtered.sort(function (a, b) {
        if (state.sort === "price-asc") return (a.ourPrice == null ? Infinity : a.ourPrice) - (b.ourPrice == null ? Infinity : b.ourPrice);
        if (state.sort === "price-desc") return (b.ourPrice == null ? -Infinity : b.ourPrice) - (a.ourPrice == null ? -Infinity : a.ourPrice);
        if (state.sort === "discount-desc") return (b.discountPercent || 0) - (a.discountPercent || 0);
        if (state.sort === "lead-asc") return (a.leadDays || Infinity) - (b.leadDays || Infinity);
        return a.title.localeCompare(b.title, "de", { numeric: true, sensitivity: "base" });
      });
      return filtered;
    }

    function priceMarkup(product) {
      if (product.priceOnRequest) {
        return '<div class="bauer-price-request"><strong>Preis auf Anfrage</strong><span>Fracht wird individuell geprüft</span></div>';
      }
      return '<div class="bauer-price-row">' +
        '<div class="bauer-price-row__main"><strong>' + formatCurrency(product.ourPrice) + '</strong><span>Unser Preis inkl. Fracht</span></div>' +
        '<div class="bauer-price-row__uvp"><s>UVP ' + formatCurrency(product.uvpInclFreight) + '</s><strong>–' + escapeHtml(product.discountPercent.toFixed(1).replace(".", ",")) + ' %</strong></div>' +
      '</div>';
    }

    function cardMarkup(product) {
      var area = product.productAreas[0] || "BAUER Südlohn";
      var variant = product.article && product.article !== product.title ? product.article : (product.product || "BAUER Industrieprodukt");
      var gtin = product.gtin || "nicht angegeben";
      var packaging = product.packagingQuantity > 1 ? " · Verpackungsmenge: " + product.packagingQuantity : "";
      return '<article class="bauer-product-card" itemscope itemtype="https://schema.org/Product">' +
        '<div class="bauer-product-card__stripe"></div>' +
        '<div class="bauer-product-card__body">' +
          '<meta itemprop="brand" content="BAUER GmbH">' +
          '<div class="bauer-product-card__eyebrow"><span class="bauer-product-card__area">' + escapeHtml(area) + '</span><span class="bauer-product-card__lead">' + escapeHtml(product.leadDays) + ' Arbeitstage</span></div>' +
          '<h3 itemprop="name">' + escapeHtml(product.title) + '</h3>' +
          '<p class="bauer-product-card__variant">' + escapeHtml(variant) + '</p>' +
          '<div class="bauer-product-card__codes">' +
            '<div><span>Artikelnummer</span><strong itemprop="sku">' + escapeHtml(product.articleNo) + '</strong></div>' +
            '<div><span>GTIN</span><strong>' + escapeHtml(gtin) + '</strong></div>' +
          '</div>' +
          '<div class="bauer-product-card__price" itemprop="offers" itemscope itemtype="https://schema.org/Offer">' +
            (product.ourPrice != null ? '<meta itemprop="priceCurrency" content="EUR"><meta itemprop="price" content="' + product.ourPrice.toFixed(2) + '">' : "") +
            priceMarkup(product) +
          '</div>' +
          '<p class="bauer-product-card__meta">Mindestmenge: ' + escapeHtml(product.minimumOrderQuantity) + ' ' + escapeHtml(product.orderUnit) + packaging + '</p>' +
          '<div class="bauer-product-card__actions">' +
            '<button class="bauer-button bauer-button--primary" type="button" data-add-to-cart="' + escapeHtml(product.id) + '">In die Anfrage</button>' +
            '<button class="bauer-detail-button" type="button" data-product-detail="' + escapeHtml(product.id) + '" aria-label="Details zu ' + escapeHtml(product.title) + '">i</button>' +
          '</div>' +
        '</div>' +
      '</article>';
    }

    function renderProducts(announce) {
      var filtered = filterProducts();
      var visible = filtered.slice(0, visibleLimit);
      resultCount.textContent = formatNumber(filtered.length);
      grid.innerHTML = visible.map(cardMarkup).join("");
      grid.setAttribute("aria-busy", "false");
      emptyState.hidden = filtered.length !== 0;
      loadMoreWrap.hidden = filtered.length <= visibleLimit;
      if (announce) {
        liveStatus.textContent = formatNumber(filtered.length) + " Produkte gefunden. " + formatNumber(visible.length) + " werden angezeigt.";
      }
    }

    function resetFilters() {
      state.query = "";
      state.productArea = "";
      state.productGroup = "";
      state.productType = "";
      state.productName = "";
      state.priceStatus = "";
      state.sort = "title";
      visibleLimit = pageSize;
      searchInput.value = "";
      root.querySelectorAll("[data-filter]").forEach(function (select) { select.value = ""; });
      root.querySelector("[data-sort]").value = "title";
      renderProducts(true);
    }

    function sanitizeQuantity(product, value) {
      var minimum = Math.max(1, Number(product.minimumOrderQuantity) || 1);
      var quantity = Math.round(Number(value) || minimum);
      return Math.min(9999, Math.max(minimum, quantity));
    }

    function addToCart(id) {
      var product = productById.get(id);
      if (!product) return;
      var existing = cart.find(function (item) { return item.id === id; });
      if (existing) existing.quantity = sanitizeQuantity(product, existing.quantity + 1);
      else cart.push({ id: id, quantity: sanitizeQuantity(product, product.minimumOrderQuantity) });
      saveCart(cart);
      renderCart();
      liveStatus.textContent = product.title + " wurde in den Anfragekorb gelegt.";
      openCart();
    }

    function cartSummary() {
      var total = 0;
      var hasOnRequest = false;
      var lines = cart.map(function (item) {
        var product = productById.get(item.id);
        if (!product) return null;
        var lineTotal = product.ourPrice == null ? null : product.ourPrice * item.quantity;
        if (lineTotal == null) hasOnRequest = true;
        else total += lineTotal;
        return { item: item, product: product, lineTotal: lineTotal };
      }).filter(Boolean);
      return { lines: lines, total: Math.round(total * 100) / 100, hasOnRequest: hasOnRequest };
    }

    function renderCart() {
      var summary = cartSummary();
      var itemCount = summary.lines.reduce(function (sum, line) { return sum + line.item.quantity; }, 0);
      root.querySelectorAll("[data-cart-count]").forEach(function (node) { node.textContent = itemCount; });
      cartEmpty.hidden = summary.lines.length > 0;
      cartFooter.hidden = summary.lines.length === 0;
      cartTotal.textContent = formatCurrency(summary.total) + (summary.hasOnRequest ? " + Anfragepositionen" : "");
      cartItems.innerHTML = summary.lines.map(function (line) {
        var product = line.product;
        return '<div class="bauer-cart-item">' +
          '<div><h3>' + escapeHtml(product.title) + '</h3><p class="bauer-cart-item__code">Art.-Nr. ' + escapeHtml(product.articleNo) + '</p><span class="bauer-cart-item__price">' + (line.lineTotal == null ? "Preis auf Anfrage" : formatCurrency(line.lineTotal)) + '</span></div>' +
          '<div class="bauer-cart-item__controls"><label><span class="bauer-visually-hidden">Menge</span><input type="number" min="' + escapeHtml(product.minimumOrderQuantity) + '" max="9999" step="1" value="' + escapeHtml(line.item.quantity) + '" data-cart-quantity="' + escapeHtml(product.id) + '"></label><button class="bauer-cart-item__remove" type="button" data-cart-remove="' + escapeHtml(product.id) + '">Entfernen</button></div>' +
        '</div>';
      }).join("");
      renderOrderPreview();
    }

    function renderOrderPreview() {
      var summary = cartSummary();
      orderPreview.innerHTML = summary.lines.map(function (line) {
        return '<div class="bauer-order-preview__item"><span>' + escapeHtml(line.item.quantity) + ' × ' + escapeHtml(line.product.title) + '<br>Art.-Nr. ' + escapeHtml(line.product.articleNo) + '</span><strong>' + (line.lineTotal == null ? "auf Anfrage" : formatCurrency(line.lineTotal)) + '</strong></div>';
      }).join("") + (summary.lines.length ? '<div class="bauer-order-preview__total"><span>Zwischensumme</span><strong>' + formatCurrency(summary.total) + (summary.hasOnRequest ? " + Anfragepositionen" : "") + '</strong></div>' : "");
    }

    function buildOrderBody() {
      var summary = cartSummary();
      var lines = [
        "BAUER PRODUKTANFRAGE ÜBER SHOP.EVLG.DE",
        "Hersteller: BAUER GmbH, Südlohn",
        "Preisliste: " + catalog.meta.priceListLabel,
        "",
        "POSITIONEN",
      ];
      summary.lines.forEach(function (line, index) {
        var product = line.product;
        lines.push((index + 1) + ". " + line.item.quantity + " × " + product.title);
        lines.push("   Artikelnummer: " + product.articleNo);
        lines.push("   GTIN: " + (product.gtin || "nicht angegeben"));
        lines.push("   Einzelpreis: " + (product.ourPrice == null ? "auf Anfrage" : formatCurrency(product.ourPrice)));
        lines.push("   Positionswert: " + (line.lineTotal == null ? "auf Anfrage" : formatCurrency(line.lineTotal)));
        lines.push("   Bereitstellungszeit: " + product.leadDays + " Arbeitstage");
        lines.push("");
      });
      lines.push("ZWISCHENSUMME: " + formatCurrency(summary.total) + (summary.hasOnRequest ? " zzgl. Anfragepositionen" : ""));
      lines.push("");
      lines.push("Hinweis: Unverbindliche Bestellanfrage. Verbindlichkeit entsteht erst durch die Auftragsbestätigung von EVLG.");
      return lines.join("\n");
    }

    function syncBodyLock() {
      var locked = cartDrawer.classList.contains("is-open") || productModal.classList.contains("is-open") || checkoutModal.classList.contains("is-open");
      document.body.classList.toggle("bauer-lock-scroll", locked);
    }

    function openCart() {
      overlay.hidden = false;
      cartDrawer.classList.add("is-open");
      cartDrawer.setAttribute("aria-hidden", "false");
      syncBodyLock();
      var closeButton = cartDrawer.querySelector("[data-cart-close]");
      if (closeButton) closeButton.focus();
    }

    function closeCart() {
      overlay.hidden = true;
      cartDrawer.classList.remove("is-open");
      cartDrawer.setAttribute("aria-hidden", "true");
      syncBodyLock();
    }

    function openModal(modal) {
      modal.classList.add("is-open");
      modal.setAttribute("aria-hidden", "false");
      syncBodyLock();
      var closeButton = modal.querySelector(".bauer-modal__close");
      if (closeButton) closeButton.focus();
    }

    function closeModal(modal) {
      modal.classList.remove("is-open");
      modal.setAttribute("aria-hidden", "true");
      syncBodyLock();
    }

    function openProduct(id) {
      var product = productById.get(id);
      if (!product) return;
      var categoryPath = product.categoryPaths.map(function (path) {
        return [path.productArea, path.productGroup, path.productType, path.productName].filter(Boolean).join(" › ");
      }).join("<br>");
      productModalContent.innerHTML = '<article class="bauer-product-detail">' +
        '<span class="bauer-kicker">BAUER GmbH · Südlohn</span>' +
        '<h2 id="BauerProductModalTitle-' + escapeHtml(root.dataset.sectionId) + '">' + escapeHtml(product.title) + '</h2>' +
        '<p class="bauer-product-detail__subtitle">' + escapeHtml(product.article || product.product) + '</p>' +
        '<div class="bauer-product-detail__grid">' +
          '<div class="bauer-product-detail__panel"><dl>' +
            '<dt>Hersteller</dt><dd>BAUER GmbH, Südlohn</dd>' +
            '<dt>Artikelnummer</dt><dd>' + escapeHtml(product.articleNo) + '</dd>' +
            '<dt>GTIN</dt><dd>' + escapeHtml(product.gtin || "nicht angegeben") + '</dd>' +
            '<dt>Produkt</dt><dd>' + escapeHtml(product.product) + '</dd>' +
            '<dt>Produkttyp</dt><dd>' + escapeHtml(product.productTypes.join(", ")) + '</dd>' +
            '<dt>Bereitstellung</dt><dd>' + escapeHtml(product.leadDays) + ' Arbeitstage</dd>' +
            '<dt>Mindestmenge</dt><dd>' + escapeHtml(product.minimumOrderQuantity) + ' ' + escapeHtml(product.orderUnit) + '</dd>' +
            '<dt>Verpackungsmenge</dt><dd>' + escapeHtml(product.packagingQuantity) + ' ' + escapeHtml(product.contentUnit) + '</dd>' +
          '</dl><div class="bauer-product-detail__path"><strong>Kategorie</strong><br>' + categoryPath + '</div></div>' +
          '<div class="bauer-product-detail__price">' + priceMarkup(product) + '<p class="bauer-product-card__meta">Preis inklusive Fracht, vorbehaltlich Prüfung. Gesetzliche Umsatzsteuer gemäß Shop-Hinweis.</p><button class="bauer-button bauer-button--primary bauer-button--wide" type="button" data-add-to-cart="' + escapeHtml(product.id) + '">In die Anfrage übernehmen</button></div>' +
        '</div>' +
      '</article>';
      openModal(productModal);
      try { history.replaceState(null, "", "#bauer-produkt=" + encodeURIComponent(product.id)); } catch (error) { /* optional */ }
    }

    function openCheckout() {
      if (!cart.length) {
        openCart();
        return;
      }
      closeCart();
      renderOrderPreview();
      openModal(checkoutModal);
    }

    searchInput.addEventListener("input", function () {
      state.query = searchInput.value;
      visibleLimit = pageSize;
      renderProducts(true);
    });

    root.querySelector("[data-search-clear]").addEventListener("click", function () {
      searchInput.value = "";
      state.query = "";
      visibleLimit = pageSize;
      renderProducts(true);
      searchInput.focus();
    });

    root.querySelectorAll("[data-filter]").forEach(function (select) {
      select.addEventListener("change", function () {
        state[select.dataset.filter] = select.value;
        visibleLimit = pageSize;
        renderProducts(true);
      });
    });

    root.querySelector("[data-sort]").addEventListener("change", function (event) {
      state.sort = event.target.value;
      renderProducts(true);
    });

    root.querySelectorAll("[data-reset-filters]").forEach(function (button) { button.addEventListener("click", resetFilters); });
    root.querySelector("[data-load-more]").addEventListener("click", function () {
      visibleLimit += pageSize;
      renderProducts(true);
    });

    root.addEventListener("click", function (event) {
      var addButton = event.target.closest("[data-add-to-cart]");
      if (addButton) {
        addToCart(addButton.dataset.addToCart);
        if (productModal.classList.contains("is-open")) closeModal(productModal);
        return;
      }
      var detailButton = event.target.closest("[data-product-detail]");
      if (detailButton) openProduct(detailButton.dataset.productDetail);
      var removeButton = event.target.closest("[data-cart-remove]");
      if (removeButton) {
        cart = cart.filter(function (item) { return item.id !== removeButton.dataset.cartRemove; });
        saveCart(cart);
        renderCart();
      }
    });

    cartItems.addEventListener("change", function (event) {
      var input = event.target.closest("[data-cart-quantity]");
      if (!input) return;
      var product = productById.get(input.dataset.cartQuantity);
      var item = cart.find(function (candidate) { return candidate.id === input.dataset.cartQuantity; });
      if (!product || !item) return;
      item.quantity = sanitizeQuantity(product, input.value);
      input.value = item.quantity;
      saveCart(cart);
      renderCart();
    });

    root.querySelectorAll("[data-cart-open]").forEach(function (button) { button.addEventListener("click", openCart); });
    root.querySelectorAll("[data-cart-close]").forEach(function (button) { button.addEventListener("click", closeCart); });
    root.querySelector("[data-checkout-open]").addEventListener("click", openCheckout);
    root.querySelector("[data-product-close]").addEventListener("click", function () { closeModal(productModal); });
    root.querySelector("[data-checkout-close]").addEventListener("click", function () { closeModal(checkoutModal); });
    overlay.addEventListener("click", closeCart);

    [productModal, checkoutModal].forEach(function (modal) {
      modal.addEventListener("click", function (event) {
        if (event.target === modal) closeModal(modal);
      });
    });

    document.addEventListener("keydown", function (event) {
      if (event.key !== "Escape") return;
      if (productModal.classList.contains("is-open")) closeModal(productModal);
      else if (checkoutModal.classList.contains("is-open")) closeModal(checkoutModal);
      else if (cartDrawer.classList.contains("is-open")) closeCart();
    });

    if (orderForm) {
      orderForm.addEventListener("submit", function (event) {
        if (!cart.length) {
          event.preventDefault();
          closeModal(checkoutModal);
          openCart();
          liveStatus.textContent = "Bitte wählen Sie mindestens ein Produkt aus.";
          return;
        }
        orderBody.value = buildOrderBody();
      });
    }

    var successMessage = root.querySelector("[data-form-success]");
    if (successMessage) {
      cart = [];
      saveCart(cart);
      renderCart();
      openModal(checkoutModal);
      setTimeout(function () { successMessage.focus(); }, 50);
    }

    renderCart();
    renderProducts(false);

    var hashMatch = window.location.hash.match(/^#bauer-produkt=(.+)$/);
    if (hashMatch) {
      var hashId = decodeURIComponent(hashMatch[1]);
      if (productById.has(hashId)) setTimeout(function () { openProduct(hashId); }, 0);
    }
  }

  function initAll(scope) {
    (scope || document).querySelectorAll("[data-bauer-root]").forEach(initCatalog);
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", function () { initAll(document); });
  else initAll(document);

  document.addEventListener("shopify:section:load", function (event) { initAll(event.target); });
})();
